import axios from "axios";

// Récupère l'URL depuis le fichier .env, ou utilise localhost par défaut
const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:3000/api"
});

// AJOUT TOKEN AUTO
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default API;